module.exports = __webpack_public_path__ + "img/adaptations10.a1672f2d.png";